module.exports = __webpack_public_path__ + "img/Media-Play.8e38a8a2.svg";